import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import Select from "react-select";
import Tabs from "react-responsive-tabs";
import { Button, Card, CardBody, Input, CardHeader, Col, Row } from "reactstrap";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import Common from "../Common";
import { getInitials, getSessionValue, groupByDate, isAgentAccount, isMobile, parseJSON } from "../../Common/Appcommon";
import requestApiService from "../../services/requestApi.service";
import "./index.css";
import DateFilter from "../../Common/DateFilter.js"
import NoRecordFound from "../Common/NoRecordFound";
import TooltipItem from "../../Common/ToolTip";
import { useAppContext } from "../../Context/AppContext";

const Notifications = () => {
    const { setNotificationCount } = useAppContext();
    const [subAccountList, setSubAccountList] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);
    const [filterData, setFilterData] = useState({});
    const [formData, setFormData] = useState({});
    const [notificationsTabs, setNotificationsTabs] = useState([]);
    const [expandedId, setExpandedId] = useState("");

    useEffect(() => {
        loadFormData();
        let menuList = getSessionValue('menus');
        let menus = (menuList !== '' && menuList !== undefined && menuList !== 'undefined' && menuList !== null) ? parseJSON(menuList) : [];
        let accountMenu = menus[2] !== undefined ? menus[2] : [];
        let allOption = { label: "All", value: "all" };
        let accountList = [allOption, 
            ...accountMenu.map(([appid, companyname]) => ({
                value: appid,
                label: companyname
            }))
        ];
        setFilterData(prev => ({
            ...prev,
            "subaccount": allOption
        }))
        setSubAccountList(accountList);
    }, [currentTab]);
    
    useEffect(() => {
        setTabView(formData);
    }, [expandedId]);

    const loadFormData = async (filter = null) => {
        if(!filter && Object.keys(filterData).length === 0){
            return;
        }
        try {
            let params = {
                ENTITY: "AIPROCESSOR",
                OPERATION: "GET_NOTIFICATIONS_LOGS",
                status: currentTab,
                filterData: filter ? filter : filterData
            }
            setShowLoader(true);
            let response = await requestApiService.processServerRequest(params);
            if(response.issuccess){
                let data = response.data;
                let grouped = groupByDate(data);
                setTabView(grouped);
            }
            setShowLoader(false);
        } catch (error) {
            console.error("Failed to load form data:", error);
        }
    };

    const processNotiUpdate = async (formid, up_status) => {
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "UPDATE_NOTIFICATIONS_LOGS",
            status: currentTab,
            formid: formid,
            up_status: up_status
        }
        setShowLoader(true);
        let response = await requestApiService.processServerRequest(params);
        if(response.issuccess){
            let dataarr = response.data;
            let data = dataarr[0];
            data = groupByDate(data);
            setTabView(data);
            let count = dataarr[1];
            setNotificationCount(count);
        }
        setShowLoader(false);
    }

    const setTabView = (formData) => {
        let notificationsTabs = [
            {
                label: "Other",
                component: NotificationList(formData),
            },
            {
                label: "Important",
                component: NotificationList(formData),
            },
            {
                label: "Cleared",
                component: NotificationList(formData),
            }
        ];
        setNotificationsTabs(notificationsTabs);
    };

    const handleTabChange = (index) => {
        setCurrentTab(index)
    }

    const handleSelect = (name, options) => {
        const updatedFilter = {
            ...filterData,
            [name]: options
        };
        setFilterData(updatedFilter);
        loadFormData(updatedFilter);
    };

    const handleDateChange = async (startDate, endDate) => {
        if (startDate && endDate) {
            let dateobj = {};
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(23, 59, 59, 999);
            const timeDifference = endDate.getTime() - startDate.getTime();
            const numberOfDays = Math.floor(timeDifference / (1000 * 3600 * 24)) + 1;
            dateobj['date_filter'] = [startDate, endDate];
            dateobj['noofdays'] = numberOfDays;
            const updatedFilter = {
                ...filterData,
                dateFilter: dateobj
            };
            setFilterData(updatedFilter);
            loadFormData(updatedFilter);
        }
    }

    const processExpanded = (id, formData) => {
        const nextId = expandedId === id ? "" : id;
        setFormData(formData);
        setExpandedId(nextId);
    };
    

    const getSimpleTabs = () => {
        return notificationsTabs.map(({ label, component, icon }, index) => ({
            key: index,
            title: label,
            tabClassName: "",
            panelClassName: "notification_panel",
            getContent: () => component,
        }));
    }

    const NotificationList = (formData) => {
        let rowCount = 0;
        return (
            <Fragment>
                {  
                    Object.keys(formData).length > 0 &&
                    Object.entries(formData).map(([key, values], val_ind) => (
                        values && 
                        values.length > 0 ? (
                            <div className="p-3 notification-container">
                                <div className="notification-header">
                                    {key}
                                </div>
                                <Card className="notification-group mt-1 transition-all duration-300">
                                    {
                                        values.map(({id, status, subject, content, account_name, color}, index) => (
                                            rowCount++,
                                            id ? (
                                                <CardBody className="d-flex notification-list gap-3">
                                                    <div className="noti-card" onClick={() => processExpanded(id, formData)}>
                                                        <div className="noti-header mb-1">
                                                            <TooltipItem id={"notification_" + val_ind + "_" + index} text={account_name} content={
                                                                <span className="me-2 rounded-user" style={{backgroundColor: color}}>
                                                                    {getInitials(account_name)}
                                                                </span>
                                                            } />
                                                            <span className="subject">{subject}</span>
                                                        </div>
                                                        <div className={`noti-content ${expandedId === id ? 'expanded' : 'collapsed'}`}>
                                                            <span>{content}</span>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-3">
                                                        {/* {
                                                            content.length > 100 ? (
                                                                <span className="w-50 cursor-pointer text-d-underline font-bold theme-c-link d-flex align-items-end">{expandedId === id ? "" : "Read More"}</span>
                                                            ) : null
                                                        } */}
                                                        <Button 
                                                            className="theme-bg-g" 
                                                            onClick={(e) => {
                                                                processNotiUpdate(id, status === "1" ? "0" : "1");
                                                            }}
                                                        >
                                                            {
                                                                status === "1" ? (
                                                                    <i class="fi fi-sr-star"></i>
                                                                ) : (
                                                                    <i class="fi fi-rr-star"></i>
                                                                )
                                                            }
                                                        </Button>
                                                        <Button 
                                                            className="theme-bg-g" 
                                                            onClick={(e) => {
                                                                processNotiUpdate(id, status === "2" ? "0" : "2")
                                                            }}
                                                        >
                                                            {
                                                                status === "2" ? (
                                                                    "Undo"
                                                                ) : (
                                                                    "Clear"
                                                                )
                                                            }
                                                        </Button>
                                                    </div>
                                                </CardBody>
                                            ) : null
                                        ))
                                    }
                                </Card>
                            </div>
                        ) : (
                            <></>
                        )
                    ))
                }
                {
                    (rowCount === 0 && !showLoader) &&
                    <NoRecordFound isOnlyContent={true} noRecordTitle={"No notification found."}/>
                }
            </Fragment>
        )
    }

    const titleBody = () => {
        return (
            <Fragment>
                <div className={`d-flex justify-content-end ${isMobile() && 'p-2'} noti-header-body`}>
                    <div className='me-2 filter-width'>
                        <Select
                            options={subAccountList}
                            className="basic-multi-select wa-select__control"
                            classNamePrefix="wa-select"
                            value={filterData.subaccount}
                            menuPlacement="auto"
                            isSearchable={false}
                            onChange={(selectedOption) =>  handleSelect('subaccount', selectedOption)}
                        />
                    </div>
                    <div>
                        <DateFilter  handleDateChange={handleDateChange} defaultSelectIndex={3}/>
                    </div>
                </div>
            </Fragment>
        );
    }

    const mainContent = () => {
        return(
            <Fragment>            
                <div className='w-100 notification-container'>
                    <Row>
                        <Col md="12">
                            <Tabs 
                                tabsWrapperClass="body-tabs notification_tab" 
                                activeTab={"1"}
                                showMore={true}
                                transform={true}
                                showInkBar={true}
                                selectedTabKey={currentTab}
                                transformWidth={600}
                                onChange={handleTabChange}
                                items={getSimpleTabs()}
                            />
                        </Col>
                    </Row>
                </div>
            </Fragment>
        )
    }

    return(
        <Fragment>
            <Common
                mainLoader={showLoader}
                title={"Notifications"}
                titleContent={"Notifications"}
                titleBody={titleBody()}
                mainContent={mainContent()}
            />
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);